var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3427 12.2075L13.628 15.2495L16.9183 15.5321C17.1465 15.5518 17.2394 15.8366 17.0662 15.9865L14.5704 18.1488L15.3183 21.3655C15.3701 21.589 15.1279 21.7649 14.9319 21.6461L12.1042 19.9407L9.27643 21.6461C9.07986 21.7643 8.83816 21.5885 8.89003 21.3655L9.63793 18.1488L7.14163 15.986C6.9684 15.8361 7.06072 15.5513 7.28945 15.5316L10.5798 15.2489L11.8651 12.2075C11.9543 11.9959 12.2535 11.9959 12.3427 12.2075V12.2075Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36052 9.72377L7.13792 8.72531L5.21762 10.2253C5.08438 10.3293 4.89118 10.222 4.90951 10.054L5.17225 7.63173L3.15226 6.2689C3.01195 6.17414 3.05453 5.95745 3.22015 5.92316L5.60503 5.42445L6.2767 3.08239C6.32354 2.91974 6.54248 2.89336 6.62648 3.03995L7.83804 5.15413L10.2736 5.06914C10.4425 5.06313 10.5356 5.2634 10.4219 5.38894L8.78559 7.19448L9.61869 9.48383C9.67677 9.64301 9.51503 9.79333 9.36052 9.72377V9.72377Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.252 7.57516L17.7658 7.99456L18.8432 6.85128C18.918 6.77201 19.0516 6.82151 19.0563 6.93038L19.1252 8.49965L20.5455 9.17102C20.6441 9.21772 20.6381 9.35997 20.5359 9.39798L19.0648 9.94851L18.8653 11.5066C18.8513 11.6148 18.7144 11.653 18.6465 11.5677L17.6682 10.3387L16.1244 10.6305C16.0173 10.6508 15.9384 10.5323 15.9986 10.4412L16.8652 9.13089L16.1109 7.75326C16.0584 7.65749 16.1468 7.54591 16.252 7.57516V7.57516Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.685244e6af21f51f5141feb4ef8262c7.svg";
export { ForwardRef as ReactComponent };